module.exports = __webpack_public_path__ + "static/firkraag-mtg_cls-c3f1683e8b958a8ab9ed645761459b0b.jpg";